const AggregateScript = (props: any) => {
    const {name, image, description, offers, aggregateRating} = props;
    return (
        <script
            type="application/ld+json"
            id={name}
            dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                    '@context': 'https://schema.org/',
                    '@type': 'Product',
                    name: name,
                    image: image,
                    description: description,
                    brand: {
                        '@type': 'Brand',
                        name: 'Debut Infotech'
                    },
                    offers: offers,
                    aggregateRating: aggregateRating
                })
            }}
        />
    );
};

export default AggregateScript;
